// import React, { use } from "react";
// import { RiArrowRightUpLine } from "react-icons/ri";
// import { useNavigate } from "react-router-dom";
// export default function JobList() {
//     const navigate = useNavigate();
//     const jobs = Array(6).fill({
//         title: "Financial Analyst",
//         date: "November 26, 2025",
//         location: "Bhubaeswar",
//         description:
//             "That’s why the highly skilled and dedicated recruitment team at NaXo Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients.",
//     });

//     return (
//         <div className="w-full">
//             <div className="w-full flex justify-center mt-10">
//                 <div className="w-full max-w-5xl bg-white shadow-lg rounded-2xl p-5 flex items-center space-x-3 border">
//                     {/* Location */}
//                     <div className="flex items-center px-4 py-3 bg-gray-100 rounded-xl text-gray-600 text-sm w-1/3 cursor-pointer">
//                         Patia, Bhubaneswar
//                         <span className="ml-2">▼</span>
//                     </div>


//                     {/* Job Title */}
//                     <input
//                         type="text"
//                         placeholder="Job Title"
//                         className="flex-1 px-4 py-3 bg-gray-100 rounded-xl text-gray-600 text-sm outline-none"
//                     />


//                     {/* Search Button */}
//                     <button className="px-6 py-3 bg-indigo-900 text-white rounded-xl text-sm flex items-center space-x-2 hover:bg-indigo-800 transition">
//                         <span>🔍</span>
//                         <span>Search</span>
//                     </button>
//                 </div>
//             </div>
//             <div className="w-full  max-w-[1400px] mx-auto px-6 py-14">
//                 <h2 className="text-3xl font-bold text-gray-900 mb-2">Find out more about our IT support</h2>
//                 <p className="text-gray-600 mb-6 text-sm md:text-base max-w-xl">
//                     Whether you need a full IT team or specialized consultation, Integris can help.
//                 </p>

//                 <button className="mb-8 px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition">
//                     Upload Resume
//                 </button>

//                 <div className="space-y-4">
//                     {jobs.map((job, index) => (
//                         <div
//                             onClick={() => navigate("/career-details")}
//                             key={index}
//                             className={`p-5 rounded-xl shadow-sm border md:flex md:items-center md:justify-between transition hover:shadow-md ${index === 2 ? "bg-blue-700  border-indigo-700" : ""
//                                 }`}
//                         >
//                             <div className="md:flex md:items-center md:space-x-4">
//                                 <span
//                                     className={`text-xl font-bold ${index === 2 ? "text-white" : "text-blue-600"}`}
//                                 >
//                                     01.
//                                 </span>
//                                 <div>
//                                     <h3 className={`text-lg font-semibold mb-1 ${index === 2 ? "text-white" : "text-gray-900"}`}>
//                                         {job.title}
//                                     </h3>
//                                     <p
//                                         className={`text-xs mb-2 ${index === 2 ? "text-gray-200" : "text-gray-500"}`}
//                                     >
//                                         {job.date} | {job.location}
//                                     </p>
//                                     <p className={`text-sm leading-relaxed ${index === 2 ? "text-gray-100" : "text-gray-600"}`}>
//                                         {job.description}
//                                     </p>
//                                 </div>
//                             </div>

//                             <div className="mt-4 md:mt-0 flex justify-end">
//                                 <div
//                                     className={`w-10 h-10 rounded-full flex items-center justify-center cursor-pointer transition ${index === 1
//                                             ? "bg-white text-indigo-700"
//                                             : "bg-blue-100 text-blue-600 hover:bg-blue-200"
//                                         }`}
//                                 >
//                                    <RiArrowRightUpLine className="w-7 h-7" />
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }


import React, { useState } from "react";
import { RiArrowRightUpLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

// Job Data
export const jobs = [
    {
        id: 1,
        title: "Financial Analyst",
        date: "November 26, 2025",
        location: "Bhubaneswar",
        description: "That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients",
    },
    {
        id: 2,
        title: "UI/UX Designer",
        date: "November 28, 2025",
        location: "Bhubaneswar",
        description: "That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients",
    },
    {
        id: 3,
        title: "Recruiter – Talent Acquisition",
        date: "November 30, 2025",
        location: "Vadodara",
        description: "That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients",
    },
    {
        id: 4,
        title: "Software Developer",
        date: "December 2, 2025",
        location: "Remote",
        description: "That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients",
    },
    {
        id: 5,
        title: "HR Executive",
        date: "December 4, 2025",
        location: "Bhubaneswar",
        description: "That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients",
    },
];

export default function JobList() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("All");

    // Filter Logic
    const filteredJobs = jobs.filter(
        (job) =>
            (selectedLocation === "All" || job.location === selectedLocation) &&
            job.title.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="w-full">
            {/* Search Row */}
            <div className="w-full flex justify-center mt-10">
                <div data-aos="fade-up" data-aos-duration="1000" className="w-full max-w-5xl bg-white shadow-lg rounded-2xl p-5 flex items-center space-x-3 border">

                    {/* Dropdown */}
                    <select
                        className="px-4 py-3 bg-gray-100 rounded-xl w-1/3 text-sm"
                        onChange={(e) => setSelectedLocation(e.target.value)}
                    >
                        <option value="All">All</option>
                        <option value="Bhubaneswar">Bhubaneswar</option>
                        <option value="Vadodara">Vadodara</option>
                        <option value="Remote">Remote</option>
                    </select>

                    {/* Search */}
                    <input
                        type="text"
                        placeholder="Job Title"
                        className="flex-1 px-4 py-3 bg-gray-100 rounded-xl text-sm outline-none"
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    {/* Button */}
                    <button className="px-6 py-3 bg-indigo-900 text-white rounded-xl">
                        🔍 Search
                    </button>
                </div>
            </div>

            {/* Jobs */}
            <div className="w-full max-w-[1400px] mx-auto px-6 py-14">
                <h2 data-aos="fade-up" data-aos-duration="1000" className="text-3xl font-semibold font-SpaceGrotesk text-primaryColor mb-2">Find out more about our IT support</h2>
                <div data-aos="fade-up" data-aos-duration="1000" className="flex flex-col md:flex-row md:items-center md:justify-between">
                    <p className="text-gray-600 mb-6 text-sm md:text-base max-w-xl">
                        Whether you need a full IT team or specialized consultation, Integris can help.
                    </p>

                    <button className="mb-8 px-4 py-2 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700 transition">
                        Upload Resume
                    </button>
                </div>
                <div className="space-y-4">
                    {filteredJobs.map((job,index) => (
                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100}
                            key={job.id}
                            onClick={() => navigate(`/career-details/${job.id}`)}
                            className="p-5 rounded-xl shadow-sm border flex justify-between cursor-pointer hover:shadow-md hover:bg-[#292c6f] hover:text-white transition hover:border-indigo-600"
                        >
                            <div className="flex hover:text-white space-x-4">
                                <span className="text-xl font-bold text-blue-600 ">
                                    {String(job.id).padStart(2, "0")}.
                                </span>
                                <div>
                                    <h3 className="text-lg font-semibold">{job.title}</h3>
                                    <p className="text-xs">
                                        {job.date} | {job.location}
                                    </p>
                                    <p className="text-sm hover:text-white mt-1">{job.description}</p>
                                </div>
                            </div>

                            {/* Arrow */}
                            <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center">
                                <RiArrowRightUpLine className="w-7 h-7" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
